export default __webpack_public_path__ + "static/media/image6.a53dc5fe.jpg";